import React from 'react'
import { ErrorAnnotations } from '../../domain/Error'
import { Alert } from '../../ui/alert'

interface Props {
    annotations: ErrorAnnotations
}

export class Context extends React.Component<Props> {
    public render() {
        const { annotations } = this.props
        const anyData = Object.keys(annotations).length > 0

        return [
            <table key="table" className="table table-striped">
                <tbody>
                    {Object.entries(annotations).map(([key, value]) => (
                        <tr key={key}>
                            <th>{key}</th>
                            <td>{value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>,
            <Alert key="alert" level="info" compact={anyData} additionalClasses={anyData ? undefined : 'tw-m-8'}>
                Want to add extra context to this error from your application? See the{' '}
                <a
                    href="https://support.tideways.com/documentation/reference/php-extension/custom-metadata.html"
                    target="_blank"
                    rel="noreferrer"
                >
                    custom variables API in the PHP Extension
                </a>
            </Alert>,
        ]
    }
}

export default Context
